var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('message-page-with-image',{attrs:{"title":"Timeout","subtitle":_vm.message,"imgAlt":"Sad Kanye","imgSrc":_vm.kanyeImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }